<template>
  <v-container class="mt-9">
    <SubHeader
      :headerProps="headerProps"
      :search="search"
      :items="items"
      @handleSearch="handleSearch"
    />
    <v-card flat outlined>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        class="elevation-0"
      >
        <template v-slot:item.data_hora_viagem="{ item }">
          <span>{{ new Date(item.data_hora_viagem).toLocaleString() }}</span>
        </template>
        <template v-slot:item.realizado="{ item }">
          <span>{{ item.realizado === "1" ? "Sim" : "Não" }}</span>
        </template>
        <template v-slot:item.action="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                small
                class="mr-2"
                color="primary"
                @click="editar(item.id)"
                >mdi-pencil</v-icon>
            </template>
            <span>Editar Escala</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                small
                color="error"
                @click="deleteItem(item.id)"
                >mdi-delete</v-icon
              >
            </template>
            <span>Excluir Escala</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import SubHeader from "@/components/SubHeader";
export default {
  components: {
    SubHeader,
  },
  data: () => ({
    headerProps: {
      title: "Gerenciar Escalas de Viagens",
      btns: [
        {
          text: "Novo",
          color: "primary",
          action: () => {},
          icon: "mdi-plus",
          path: "/escalas/new",
          isRedirector: true,
        },
        {
          text: "Recarregar",
          color: "primary",
          action: () => {},
          icon: "mdi-update",
          path: "",
          isRedirector: false,
        },
      ],
    },
    dialog: false,
    search: "",
    headers: [
      { text: "Data e Hora", value: "data_hora_viagem", sortable: false },
      { text: "Viagem", value: "viagem", sortable: false },
      { text: "Ônibus", value: "bus", sortable: false },
      { text: "Motorista", value: "motorista", sortable: false },
      { text: "Origem e Destino", value: "rota", sortable: false },
      { text: "Realizado", value: "realizado", sortable: false },
      { text: "Ações", align: "right", value: "action", sortable: false },
    ],
    items: [],
  }),
  created() {
    this.initialize();
    this.headerProps.btns[1].action = () => this.initialize();
  },
  methods: {
    handleSearch: function (value) {
      this.search = value;
    },
    initialize() {
      this.items = [];
      this.$store.dispatch("activeLoader", true);
      this.$http.get("/escalas").then((r) => {
        this.items = r.data;
        this.$store.dispatch("activeLoader", false);
      });
    },
    editar(id) {
      this.$router.push(`/escalas/editar/${id}`);
    },
    deleteItem(id) {
      let c = confirm("Deseja apagar o registro?");
      if (c) {
        this.$store.dispatch("activeLoader", true);
        this.$http.post(`/escalas/delete/${id}`).then((r) => {
          this.$store.dispatch("activeLoader", false);
          alert(r.data.success);
          this.initialize();
        });
      }
    },
  },
};
</script>

